module.exports = __webpack_public_path__ + "img/half-circle-2-light.600281cd.svg";